"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  box-sizing: border-box;\n  font-family: ", ";\n  display: ", ";\n  text-indent: ", ";\n\n  &::placeholder {\n    ", "\n    color: ", ";\n    font-family: ", ";\n  }\n\n  ", "\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var textAreaStyle = (0, _styledSystem.variant)({
  key: 'textAreas'
});

var TextInput = _styledComponents.default.textarea.attrs({
  type: 'text'
})(_templateObject(), _styledSystem.borderRadius, _styledSystem.borders, _styledSystem.borderColor, _styledSystem.boxShadow, _styledSystem.color, _styledSystem.fontFamily, _styledSystem.fontSize, _styledSystem.fontWeight, _styledSystem.height, _styledSystem.lineHeight, _styledSystem.space, _styledSystem.textAlign, textAreaStyle, _styledSystem.width, function (props) {
  return props.theme[props.fontFamily] || 'Helvetica, Arial, sans-serif';
}, function (props) {
  return props.display || 'inline';
}, function (props) {
  return props.textIndent || '0';
}, _styledSystem.fontSize, function (props) {
  return props.placeholderColor || props.theme.colors.wagGray;
}, function (props) {
  return props.theme[props.fontFamily] || 'Helvetica, Arial, sans-serif';
}, function (props) {
  return !props.resizeable && "\n    resize: none;\n  ";
}, function (props) {
  return props.error && "\n    border: 1px solid " + (props.theme.colors.wagRed || 'red') + ";\n  ";
});

TextInput.defaultProps = {
  variant: 'default',
  height: [95, 110],
  borderRadius: 3,
  resizeable: false,
  bg: ['wagGray', 'white']
};
var _default = TextInput;
exports.default = _default;